<template>
    <section>
        <div>
            <form @submit.prevent="searchInfo" novalidate>
            <div class="t-body3 mgt-6 t-color-bodyGrayA">
                {{$t('16')}}
                <!-- 계정을 검색하려면 이름과 가입시 사용한 인증코드를 입력하세요. -->
            </div>
            <div class="mgt-40">
                <div class="mdc-text-field mdc-text-field--outlined w-full"
                    :class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="firstNameEl"
                >
                    <input type="text" class="mdc-text-field__input"
                        v-model="firstName"
                        v-validate="'required'"
                        ref="firstName"
                        id="firstName"
                        name="firstName"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('17')}}
                            <!-- 성 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper t-color-mainBtn mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && firstNameInvalidCheck">
                        {{$t('949')}}
                        <!-- * 성을 입력해주세요. -->
                    </span>
                </div>

                <div class="mdc-text-field mdc-text-field--outlined w-full mgt-17"
                    :class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="lastNameEl"
                >
                    <input type="text" class="mdc-text-field__input"
                        id="lastName"
                        name="lastName"
                        v-model="lastName"                            
                        v-validate="'required'"
                        ref="lastName"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('18')}}
                            <!-- 이름 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
                <div class="t-helper t-color-mainBtn mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && lastNameInvalidCheck">
                        {{$t('950')}}
                        <!-- * 이름을 입력해주세요. -->
                    </span>
                </div>

                <div class="mdc-text-field mdc-text-field--outlined w-full mgt-17"
                    :class="submitState && certiNumberInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="certiNumberEl"
                >
                    <input type="text" class="mdc-text-field__input"
                        id="certiNumber"
                        name="certiNumber"
                        v-model="certiNumber"                            
                        v-validate="'required'"
                        ref="certiNumber"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('19')}}
                            <!-- 인증코드 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && certiNumberInvalidCheck">
                        {{$t('953')}}
                        <!-- 인증코드를 입력해주세요. -->
                    </span>
                </div>
            </div>

            <div class="mgt-27">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('20')}}
                    <!-- 검색 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8 t-color-secondaryBtnText" @click="cancelFindId()" @keypress="cancelFindId()" type="button" tabindex="0">
                    {{$t('21')}}
                    <!-- 취소 -->
                </button>
                
                
            </div>

            </form>
        </div>

        
    </section>
</template>

<script>
/**
 * 계정 찾기 Step2 컴포넌트 (find account Step2 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '@/mixins/findId.js'

export default {
    data() {
        return {
            firstName: '',
            lastName: '',
            certiNumber: '',
            firstNameTextField: null,
            lastNameTextField: null,
            certiNumberTextField: null,
            submitState: false
        }
    },

    mixins: [findIdMixin],

    computed : {
        ...mapState('findId',{
            findId : state => state,
        }),
       
        // firstName 유효성 Check 및 아이콘(validation check firstName)
        firstNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('firstName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
            return returnValue
        },

        // lastName 유효성 Check 및 아이콘(validation check lastName)
        lastNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('lastName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
            return returnValue
        },

        // certiNumber 유효성 Check 및 아이콘(validation check certiNumber)
        certiNumberInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('certiNumber')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.certiNumberTextField.valid === !returnValue ? '' : this.certiNumberTextField.valid = !returnValue
            return returnValue
        }
    },

    mounted() {
         this.setMaterialUi()
    },
    updated() {
        
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findId', ['SET_STEP1', 'SET_AUTH_METHODS', 'INIT_FINDID_STORE']),

        setMaterialUi() {
            // const firstNameTextField = document.querySelector('#firstNameEl')
            this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
            this.firstNameTextField.useNativeValidation = false

            this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
            this.lastNameTextField.useNativeValidation = false

            this.certiNumberTextField = new MDCTextField(document.querySelector('#certiNumberEl'))
            this.certiNumberTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
                
            this.firstName = this.findId.step1.firstName
            this.lastName = this.findId.step1.lastName
            this.certiNumber = this.findId.step1.code
            
            this.firstNameTextField.value = this.firstName
            this.lastNameTextField.value = this.lastName
            this.certiNumberTextField.value = this.certiNumber
        },
        
        // search information
        searchInfo() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    let params = {
                        value: '',
                        firstName: this.firstName,
                        lastName: this.lastName,
                        code: this.certiNumber,
                    }

                    this.SET_STEP1(params)

                    // 계정 찾을 인증 수단 조회(get find account auth methods)
                    findApi.findByInfo(params).then((response) => {
                        let responseData = response.data.data
                        
                        this.SET_AUTH_METHODS(responseData)

                        if (responseData.length) {
                            this.$router.push({
                                name: 'FindIdStep3'
                            })
                        }else {
                            // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                            // this.$snackOpen({contents:'검색 결과가 없습니다. 입력하신 정보를 확인 후 다시 시도해주세요.'}).then(() => {})
                            this.$snackOpen({
                                contents: this.$t('29') + ' ' + this.$t('30'),
                                btnDisplay: ''
                            }).then(() => {})
                            this.focusFirstInvalidElement()
                        }
                        
                        
                    }).catch((err) => {
                        let responseData = err.response.data.meta
                        
                        // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                        // this.$snackOpen({contents:'검색 결과가 없습니다. 입력하신 정보를 확인 후 다시 시도해주세요.'}).then(() => {})
                        this.$snackOpen({
                            contents: this.$t('29') + ' ' + this.$t('30'),
                            btnDisplay: ''
                        }).then(() => {})
                        
                        this.focusFirstInvalidElement()
                    })
                }else {
                    this.focusFirstInvalidElement()
                }
            })
        },

        focusFirstInvalidElement() {
            let invalidElementName = Object.keys(this.errors.collect())[0]
            this.$refs[`${invalidElementName}`].focus()
        }

    },

    

}
</script>